// Barrel export for all seed data
export { SEED_SUPPLEMENTS } from './seedSupplements';
export { SEED_RX } from './seedRx';
export { SEED_LONGEVITY } from './seedLongevity';
export { SEED_BUNDLES } from './seedBundles';
export { SEED_SAFETY_RULES } from './seedSafetyRules';
export { TIER1_SUPPLEMENT_SAFETY_RULES } from './tier1SupplementSafetyRules';
export { TIER2_RX_SAFETY_RULES } from './tier2RxSafetyRules';
export { TIER3_LONGEVITY_SAFETY_RULES } from './tier3LongevitySafetyRules';

import { SEED_SUPPLEMENTS } from './seedSupplements';
import { SEED_RX } from './seedRx';
import { SEED_LONGEVITY } from './seedLongevity';

import type { Product } from '../../types/formulary';

/** All 74 products combined */
export const ALL_SEED_PRODUCTS: Product[] = [
  ...SEED_SUPPLEMENTS,
  ...SEED_RX,
  ...SEED_LONGEVITY,
];
